// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-locale-provider{display:contents}", "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VLocaleProvider/VLocaleProvider.css"],"names":[],"mappings":"AAAA,mBACE,gBACF","sourcesContent":[".v-locale-provider {\n  display: contents;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
